import React from "react";
import DeviceInformationPreview from "../preview/DeviceInformationPreview";

const PrimaryDeviceInformationPreview = ({ currentDevice }) => {
  return (
    <DeviceInformationPreview
      currentDevice={currentDevice}
      isPrimaryDevice={true}
    />
  );
};

export default PrimaryDeviceInformationPreview;
